var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"contract",staticStyle:{"width":"100%","height":"850px"},attrs:{"src":_vm.src,"scrolling":"auto","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }